import React from 'react';
import { Link } from 'react-router-dom';
import { List } from 'antd';

import { QA as QAIcon } from 'src/components/Icons';

import useFavorites from '../useFavorites';
import { FavoriteType } from '../constants';
import ListItem from '../ListItem';
import { getQALink } from '../utils';

const QA: React.FC = () => {
  const { loading, entities } = useFavorites(FavoriteType.qa);

  console.log(entities);

  return (
    <List
      loading={loading}
      dataSource={entities}
      renderItem={(item) => {
        const href = getQALink(item);
        return (
          <ListItem
            key={item.id}
            icon={<QAIcon color="#5a5aee" />}
            title={item.name}
            content={item.content}
            as={Link}
            to={href}
          />
        );
      }}
    />
  );
};

export default QA;
